<div class="fantasy-panel rounded overflow-hidden">
  <div class="row mx-0">
    <div class="col-lg-7 px-0 bg-gray position-relative">
      <div class="game-summary">
        <div class="d-none d-lg-block">
          <div class="text-center line-height-18 text-info">
            <p class="pt-3 mb-1 font-size-12">{{ 'pick.player.time.left' | translate }}</p>
            <fgbcl-countdown class="font-size-14 fw-bold" [endDateTime]="game.EndDate"></fgbcl-countdown>
          </div>
          <div class="row team-vs-team d-flex justify-content-center align-items-center mx-0 mt-5">
            <div class="team home col-4">
              <img
                *ngIf="game.HomeTeamLogo"
                class="d-flex ms-auto me-auto mt-3 mt-lg-0"
                src="{{ game.HomeTeamLogo | contentImage: '7' }}"
              />
            </div>
            <div class="versus col-4 text-center">
              <div class="svg svg-info vs-svg ms-auto me-auto" [inlineSVG]="'assets/images/icons/vs.svg'"></div>
            </div>
            <div class="team away col-4">
              <img
                *ngIf="game.AwayTeamLogo"
                class="d-flex ms-auto me-auto mt-3 mt-lg-0"
                src="{{ game.AwayTeamLogo | contentImage: '7' }}"
              />
            </div>
          </div>
          <div class="line-height-18 font-size-12 text-center panel-date">
            <div class="text-info">{{ gameDate | uppercase }} - {{ gameTime }}</div>
          </div>
        </div>
        <div class="d-block d-lg-none">
          <div class="row mt-1">
            <div class="col-3 line-height-18 px-0 ms-3">
              <p class="mb-lg-0 mb-1 font-size-12">{{ 'pick.player.time.left' | translate }}</p>
              <fgbcl-countdown class="font-size-16 fw-bold" [endDateTime]="game.EndDate"></fgbcl-countdown>
            </div>
            <div class="col-lg-12 col-8 d-flex flex-column px-0">
              <div class="row team-vs-team d-flex justify-content-center align-items-center mx-0">
                <div class="team home col-3 px-0">
                  <img *ngIf="game.HomeTeamLogo" class="d-flex mx-auto" src="{{ game.HomeTeamLogo | contentImage: '6' }}" />
                </div>
                <div class="col-6 d-flex flex-column px-0">
                  <div class="versus text-center mb-2">
                    <div class="svg svg-white vs-svg ms-auto me-auto" [inlineSVG]="'assets/images/icons/vs.svg'"></div>
                  </div>
                  <div class="line-height-18 font-size-12 text-center">
                    <div class="dates">{{ gameDate | uppercase }} - {{ gameTime }}</div>
                  </div>
                </div>
                <div class="team away col-3 px-0">
                  <img *ngIf="game.AwayTeamLogo" class="d-flex mx-auto" src="{{ game.AwayTeamLogo | contentImage: '6' }}" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-5 py-2 px-3 right-col border border-disabled">
      <div class="player-select text-center d-lg-block d-flex align-items-center">
        <div class="player-image ms-lg-auto me-auto rounded-4 border border-disabled overflow-hidden bg-muted"></div>
        <div class="d-flex flex-column align-items-lg-center">
          <div class="question-text fw-bold font-size-14 text-center">
            {{ 'pick.player.next.game.no.player' | translate }}
          </div>
          <button class="btn btn-primary btn-select shadow fw-bold w-100 mb-2 rounded-4" [disabled]="true">
            {{ 'pick.player.next.game.select.button' | translate }}
          </button>
        </div>

        <fgb-fantasy-player-select-confirm [isGamePending]="true" [game]="game"> </fgb-fantasy-player-select-confirm>
      </div>
    </div>
  </div>
</div>
